import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Link } from "gatsby"

import { Container } from "./styled"

export default function AboutServices(props) {
  const { execucao, consultoria, delegacia, habeas, tribunal, defesa } = useStaticQuery(graphql`
    query {
      execucao: file(relativePath: { eq: "execucao-penal.png" }) {
        childImageSharp {
          fluid(maxWidth: 1300, maxHeight: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      consultoria: file(relativePath: { eq: "consultoria.png" }) {
        childImageSharp {
          fluid(maxWidth: 1200, maxHeight: 800) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }

      delegacia: file(relativePath: { eq: "delegacia-policia.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1200, maxHeight: 650) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }

      habeas: file(relativePath: { eq: "habeas-corpus.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1200, maxHeight: 650) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }

      tribunal: file(relativePath: { eq: "tribunal.png" }) {
        childImageSharp {
          fluid(maxWidth: 1200, maxHeight: 650) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }

      defesa: file(relativePath: { eq: "defesa.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000, maxHeight: 650) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)
  return (
    <>
      <Container>
        <section className="text-gray-600 body-font">
          <div className="text-center lg:w-3/3 w-full mt-4">
            <h2 className={`text-white text-center title-font sm:text-4xl text-3xl mb-4 font-medium`}>
              Especialistas na Área Criminal
            </h2>
          </div>
          <div className="container px-0 py-3 mx-auto">
            <div className="flex flex-wrap">
              <div className="p-1 lg:w-1/3 md:w-1/2">
                {/* <Link
                  to="/consertosDeMotores"
                  className={`text-${props.theme}-500 inline-flex items-center md:mb-2 lg:mb-0`}
                > */}
                <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                  <Img
                    className="lg:h-48 md:h-36 w-full object-cover object-center"
                    fluid={execucao.childImageSharp.fluid}
                    alt="Execução Penal"
                  />
                  <div className="p-6">
                    <h2 className="title-font text-lg font-medium text-white text-center mb-3">
                      Execução Penal
                    </h2>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Progressão de Regime
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Livramento Condicional
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Remição de Pena
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Indulto e Comutação
                    </p>
                  </div>
                </div>
                {/* </Link> */}
              </div>

              <div className="p-1 lg:w-1/3 md:w-1/2">
                {/* <Link
                  to="/consertosDeMotores"
                  className={`text-${props.theme}-500 inline-flex items-center md:mb-2 lg:mb-0`}
                > */}
                <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                  <Img
                    className="lg:h-48 md:h-36 w-full object-cover object-center"
                    fluid={consultoria.childImageSharp.fluid}
                    alt="Consultoria Jurídica"
                  />
                  <div className="p-6">
                    <h2 className="title-font text-lg font-medium text-white text-center mb-3">
                      Consultoria Jurídica
                    </h2>

                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Elaboração de pareceres embasado em estratégias defensivas
                    </p>
                  </div>
                </div>
                {/* </Link> */}
              </div>

              <div className="p-1 lg:w-1/3 md:w-1/2">
                {/* <Link
                  to="/consertosDeMotores"
                  className={`text-${props.theme}-500 inline-flex items-center md:mb-2 lg:mb-0`}
                > */}
                <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                  <Img
                    className="lg:h-48 md:h-36 w-full object-cover object-center"
                    fluid={delegacia.childImageSharp.fluid}
                    alt="Delegacia de Polícia"
                  />
                  <div className="p-6">
                    <h2 className="title-font text-lg font-medium text-white text-center mb-3">
                      Delegacia de Polícia
                    </h2>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Acompanhamento em Flagrantes
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Oitiva em Depoimentos
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Assistência na Investigação Criminal
                    </p>

                  </div>
                </div>
                {/* </Link> */}
              </div>

              <div className="p-1 lg:w-1/3 md:w-1/2">
                {/* <Link
                  to="/consertosDeMotores"
                  className={`text-${props.theme}-500 inline-flex items-center md:mb-2 lg:mb-0`}
                > */}
                <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                  <Img
                    className="lg:h-48 md:h-36 w-full object-cover object-center"
                    fluid={habeas.childImageSharp.fluid}
                    alt="Habeas Corpus(Requerimento de Liberdade)"
                  />
                  <div className="p-6">
                    <h2 className="title-font text-lg font-medium text-white text-center mb-3">
                      Habeas Corpus (Requerimento de Liberdade)
                    </h2>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Requerimento de liberdade provisória buscando garantir a proteção do direito à liberdade.
                    </p>

                  </div>
                </div>
                {/* </Link> */}
              </div>

              <div className="p-1 lg:w-1/3 md:w-1/2">
                {/* <Link
                  to="/consertosDeMotores"
                  className={`text-${props.theme}-500 inline-flex items-center md:mb-2 lg:mb-0`}
                > */}
                <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                  <Img
                    className="lg:h-48 md:h-36 w-full object-cover object-center"
                    fluid={tribunal.childImageSharp.fluid}
                    alt="Recursos Perante os Tribunais"
                  />
                  <div className="p-6">
                    <h2 className="title-font text-lg font-medium text-white text-center mb-3">
                      Recursos Perante os Tribunais
                    </h2>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Apelação Criminal
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Revisão Criminal
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Agravo em Execução
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Carta Testemunhável
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Recurso Especial
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Recurso Extraordinário
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Recurso em Sentido Estrito
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Entre outros
                    </p>
                  </div>
                </div>
                {/* </Link> */}
              </div>

              <div className="p-1 lg:w-1/3 md:w-1/2">
                {/* <Link
                  to="/consertosDeMotores"
                  className={`text-${props.theme}-500 inline-flex items-center md:mb-2 lg:mb-0`}
                > */}
                <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                  <Img
                    className="lg:h-48 md:h-36 w-full object-cover object-center"
                    fluid={defesa.childImageSharp.fluid}
                    alt="Defesas em Ações Penais"
                  />
                  <div className="p-6">
                    <h2 className="title-font text-lg font-medium text-white text-center mb-3">
                      Defesas em Ações Penais
                    </h2>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Lei de Drogas
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Violência Doméstica(Lei Maria da Penha)
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Crimes Contra a Vida
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Crimes Contra a Honra
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Crimes de Trânsito
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Assistência da Acusação Pública
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Audiência de Custódia
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Juízados de Especiais Criminais
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Crimes de Porte e Posse Ilegal de Armas
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Crimes contra o Sistema Financeiro
                    </p>
                    <p className="tracking-widest text-md title-font font-medium text-gray-200 mb-3">
                      • Entre outros
                    </p>
                  </div>
                </div>
                {/* </Link> */}
              </div>

            </div>
          </div>
        </section>
      </Container>
    </>
  )
}
